interface IMethodNames {
  newTaskMethodName: string;
  taskCompletedMethodName: string;
}

export const methodNames: IMethodNames = {
  newTaskMethodName: 'NewPendingTask',
  taskCompletedMethodName: 'TaskComplete',
};
